import { SubtleButton } from '@repo/ui/components/buttons/SubtleButton';
import UnderlineHeading from '@repo/ui/components/heading/UnderlineHeading';
import React from 'react';
import { Link } from 'react-router-dom';
import AddServiceRequestForm from '../components/forms/addServiceRequest/AddServiceRequestForm';

export default function AddServiceRequest() {
    return (
        <div className="w-full mt-6 z-10">
            <div className="flex flex-col min-[400px]:flex-row justify-between mb-6">
                <UnderlineHeading text="أضافة طلب دوره" className2='md:mb-0 mb-3'/>
                <Link to="/student-relations" className="md:mt-0 mt-4">
                    <SubtleButton className="min-[400px]:w-fit w-full">عودة للقائمة الرئيسية</SubtleButton>
                </Link>
            </div>
            <AddServiceRequestForm />
        </div>
    );
}
